<template>
	<div class="relative overflow-hidden bg-white py-16">
	  <div class="relative px-6 lg:px-8">
	  
	    <div class="mx-auto max-w-prose text-lg">
	      <h1>
	        <span class="block text-center text-lg font-semibold text-orange">Support</span>
	        <span class="mt-2 block text-center text-xl lg:text-3xl font-bold lg:leading-8 tracking-tight text-gray-900">We take your data and security seriously.</span>
	      </h1>
	      <p class="mt-8 text-base lg:text-xl leading-8 text-gray-500">Data security is as important to us as it is to you.</p>
	    </div>
	    
	    <div class="prose lg:prose-lg prose-indigo mx-auto mt-6 text-gray-500">
	      <p>Candidly, when transmitting and storing data over the Internet, there is no way to guarantee 100% security of that information.</p>

		  <p>However, we take as many measures as possible in order to protect your information from unauthorized access as best as possible using the most up to date security measures and best practices.</p>
		  
		  <p>Here's how we're working to keep your data safe:</p>
		  
		  <h3>We've Partnered with MX Technologies</h3>
		  
		  <p>We have partnered with MX Technologies, a leading Saas company in the financial technology space, to allow you the option to securely connect to supported financial institutions.</p>

		  <p>MX works with over 2,000 banks, credit unions, fintechs and more to offer secure connections to financial institutions and data. </p>

		  <p>Through this partnership with MX, should you wish to register connections with supported institutions, you will be required to enter your online banking credentials for that institution. </p>

		  <p>Do note that your credentials never touch My10x servers and are not stored by us in any manner. Instead, MX processes them directly with the respective institution, and we receive a fully encrypted authentication token, which allows us to connect to your account and data in order to import it into My10x. <strong>This token can be revoked at any time by you</strong> in the Manage Connections section of My Wallet in My10. </p>

		  <p><em>At no time do we have the ability to directly access your account in order to make changes to it.</em></p>

		  <p>As a reminder, we do fully support manual entry of all of this data, which doesn’t require you to share online banking credentials.</p>

		  <p>For more information and specifics on MX’s security processes and how they protect your data, <a href="https://hubspot.mx.com/hubfs/security-whitepaper.pdf" target="_blank" class="text-orange hover:text-orange-400">view this whitepaper.</a></p>
		  
		  <div class="border-b border-gray-200 mt-8"></div>

		  
		  <h3>We Protect Your Data</h3>
		  <p>We have spent considerable time and resources in building My10x with the most up to date security measures and best practices in order to best protect your data. Some, but not all, of these practices are outlined below:</p>
		  
		  <h4>Encrypted Data</h4>
		  
		  <p>We encrypt all data transmissions using public key cryptography algorithms such as AES-256 and AES-128, with a minimum key size of 128 bit encryption. This is the same level of encryption that most banks use when storing and processing your data.</p>

		  <h4>SSL/TLS</h4>
		  <p>My10x utilizes SSL, or Secure Sockets Layer, which is an encryption-based Internet security protocol. You may be familiar with this as you’ll see “https” in the page url and the lock icon in the browser, indicating that SSL/TLS is implemented on that website or application. SSL/TLS is used to prevent unauthorized third parties from intercepting data transmissions.</p>
		  
		  <h4>Two-Factor Authentication</h4>
		  <p>My10x offers Two-Factor Authentication (2FA) as an additional security option for users. While not impenetrable, with 2FA enabled, every time you login, we'll send you a random 6-digit code via SMS to help verify your account authentication. This helps to prevent unwanted access to your account.</p>

		  <h4>Automatic Logout After Inactivity</h4>
		  <p>My10x will also anonymously monitor your activity level when using the application, and will log you out after a set period of inactivity. This action helps to ensure your account security if you forget to logout from My10x.</p>


		  <div class="border-b border-gray-200 mt-8"></div>

		  <h3>Questions / Concerns?</h3>
		  <p>If you have any questions or concerns, please get in touch with us: my10x@10xtravel.com</p>
		  
		  

		  
	      
	    </div>
	  </div>
	</div>

</template>
